import React from "react";
import { LegalPage, LegalSection } from "../components/SiteShell";
import { usePageMeta } from "../lib/usePageMeta";

export default function RefundPolicy() {
  usePageMeta({
    title: "Refund & Cancellation Policy",
    description: "Refund and cancellation terms for Fitnudge subscriptions.",
  });

  return (
    <LegalPage
      testid="refund-page"
      title="Refund & Cancellation Policy"
      subtitle="Fitnudge is a subscription-based software service. Below are the terms governing refunds and cancellations."
      lastUpdated="30 May 2026"
    >
      <LegalSection title="Subscription Billing">
        <p>
          All subscription fees are charged in advance for the selected billing
          period (monthly or annual). Pricing is displayed on the in-app billing
          page before checkout.
        </p>
      </LegalSection>

      <LegalSection title="Cancellation">
        <p>
          You may cancel your subscription at any time from your account
          settings. Cancellation will prevent future billing but will not
          automatically generate refunds for previous charges.
        </p>
      </LegalSection>

      <LegalSection title="Refunds">
        <p>
          Payments made for subscription services are generally{" "}
          <strong>non-refundable</strong>. Refund requests may be reviewed on a
          case-by-case basis at our sole discretion. To request a refund review,
          email{" "}
          <a href="mailto:support@fitnudge.in" className="text-primary hover:underline">
            support@fitnudge.in
          </a>{" "}
          within 7 days of the charge with a brief description of your reason.
        </p>
      </LegalSection>

      <LegalSection title="Continued Access">
        <p>
          When you cancel, access to paid features continues until the end of
          the current billing period. Your data is preserved during this time
          and is not deleted automatically.
        </p>
      </LegalSection>

      <LegalSection title="Contact">
        <p>
          For any billing-related questions:{" "}
          <a href="mailto:support@fitnudge.in" className="text-primary hover:underline">
            support@fitnudge.in
          </a>
        </p>
      </LegalSection>
    </LegalPage>
  );
}
